<template>
<div class="newcontainer" >
  <div><input type="text" v-model="sName" placeholder="指令名"><input type="text" v-model="sGoto" placeholder="参数"></div>
  <div><button @click="go">跳转</button></div>
  <hr/>

    <div><input type="text" v-model="sHref" placeholder="链接"></div>
    <div><button @click="goHref">跳转</button></div>
      <hr/>
          <div><input type="text" v-model="sHref1" placeholder="链接进行编码"></div>
          <div><button @click="goHref1">跳转</button></div>
      <hr/>
      <div>token: {{token}},版本号:{{version}}</div>
<!--   <div>ios: <input type="text" v-model="sIos"></div>
  <div><button @click="goIos">跳转</button></div>
  <hr />
  <div>android: <input type="text" v-model="sAndroid"></div>
  <div><button @click="goAndroid">跳转</button></div> -->

<hr/><hr/><hr/>
<h2>外卖拼单</h2>


实付金额：<input type="text"  v-model="pricebox.total" class="total">元

<ul class="mini"> 
  <template v-for="(item,index) in pricebox.other">
    
    <li><input type="text" class="name" placeholder="名字"><input type="text" v-model="item.price">元 <span v-if="flag">计算后{{item.after}}元</span></li>
  </template>
</ul>
<button @click="addInput">增加</button><button @click="acount">计算</button>
</div>
</template>

<script>
import utils from '../assets/js/utils'
export default {
  name: 'test',
  data () {
    return{
      sName:'',
      sGoto:'',
      sHref:'',
      sHref1:'',
      token:'',
      version:'',
      flag:0,
      pricebox:{
        sum:0,
        total:'',
        other:[
          {}
        ]
      }
    }
  },
  mounted() {
    if(utils.ua.indexOf('token')>-1){
      this.token = utils.getParams('token')
      this.version = utils.getParams('hsVerison')
    }
     // this.$http({
     //    method: 'post',
     //    url: '/api/valentineactivity/getUserRedPacketNums',
     //    data: {token:this.token}
     // }).then((res)=>{

     //    // utils.hideLoading()
     //    if(res.data.status === 200){
     //    this.list = res.data.data.appHtml5
     //    }else{
     //    alert(res.data.msg)
     //    }
     //  })
  },
  methods:{
    go(){
      utils.goToApp(this.sName,this.sGoto)
    },
    goHref(){
      window.location.href = this.sHref
    },
    goHref1(){
      window.location.href = encodeURI(this.sHref1)
    },
    addInput(){
      this.pricebox.other.push({})
    },
    acount(){
       this.flag = 1
      this.$nextTick(()=> {
               var sum = 0 
         this.pricebox.other.forEach(function(val, idx, arr) {
          if(val.price){

          sum += Number(val.price)
          }
        }, 0);
      
         this.pricebox.sum = sum

         this.pricebox.other.forEach((val, idx, arr)=> {
          this.$set(val,'after',(this.pricebox.total * (Number(val.price)/ Number(this.pricebox.sum))).toFixed(2))
          // val.after = 
        }, 0);
         console.log(this.pricebox)
          // console.log(sum)
          
     
      })
   
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
div{text-align: center;}
 input{width: 15rem; height: 2rem; line-height: 2rem; border:1px solid #999; }
 button{width: 6rem; height: 2rem; line-height: 2rem; background-color: #abcdef; margin-top: 1rem;}

.total{width: 9rem;}
 .mini{margin: 0.5rem 0 0 1rem; text-align: left;
  .name{border: none; width: 3rem;}
    input{width: 8rem; height: 1.2rem; line-height: 1.2rem;}
    span{color: red}
  
 }
</style>



// WEBPACK FOOTER //
// src/components/test.vue